import styled from "styled-components";
import theme from "../../shared/theme";

export const TextBox = styled.div`
  padding-left: 15px;
  padding-right: 15px;
`;

export const ContentBox = styled.div`
  width: 100%;
  box-shadow: 0 4px 10px 0 rgba(0,0,0,.15);
  padding-top: 7em;
  padding-bottom: 30px;
  margin-bottom: 30px;
`;

export const Title = styled.h1`
  margin-top: 1em;
  color: #1b3647;
  text-align: center;
  font-weight: bold;
  @media screen and (max-width: 576px) {
    font-size: 7vw;
  }
`;

export const SubTitle = styled(Title)`
  font-size: 1em !important;
  margin-bottom: 2em;
`;

export const ColumnInput = styled.div`
  display: flex;
  align-items: baseline;
  flex-flow: column;
`;

export const Input = styled.input`
  -webkit-box-shadow: inset 0 1px 2px hsla(0, 0%, 4%, 0.1);
  box-shadow: inset 0 1px 2px hsla(0, 0%, 4%, 0.1);
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  border: solid 1px #33393d;
  color: #363636;
`;

export const InputLabel = styled.label`
  color: #363636;
  display: block;
  font-size: 1rem;
  font-weight: 700;
`;
export const Label = styled.label`
  color: ${theme.colors.defaultLabel};
  font-weight: bold;
  font-size: ${theme.font.fontSizeDefault};
  ${props => props.isError && `color: ${theme.colors.error}`}
  font-family: Open Sans,sans-serif!important;
`;

export const Radio = styled.label`
 cursor: pointer;
  color: ${theme.colors.defaultLabel};
  font-weight: bold;
  font-size: ${theme.font.fontSizeDefault};
  ${props => props.isError && `color: ${theme.colors.error}`}
  font-family: Open Sans,sans-serif!important;
`;
